import Head from "next/head";
import siteConfig from "../lib/siteConfig";
import openingHours from "../data/hours.json";

const weekdayMap = {
  ma: "Mo",
  ti: "Tu",
  ke: "We",
  to: "Th",
  pe: "Fr",
  la: "Sa",
  su: "Su",
};

const cleanTime = (str) => {
  return str
    .replace(/\./g, ":") // 8.00 -> 8:00
    .replace(/[–-]/g, "-") // en dash or hyphen -> hyphen
    .padStart(5, "0"); // optional: add leading 0 if needed
};

const hoursArray = Object.entries(openingHours).map(([day, hours]) => {
  const dayCode = weekdayMap[day.toLowerCase()];
  if (hours.toLowerCase().includes("suljettu")) {
    return `${dayCode} Closed`;
  }
  const [open, close] = hours.split(/[-–]/).map(cleanTime);
  return `${dayCode} ${open}-${close}`;
});

export default function StructuredData() {
  const data = {
    "@context": "https://schema.org",
    "@type": "VeterinaryCare",
    name: siteConfig.meta.defaultTitle,
    image: `${siteConfig.meta.siteUrl}${siteConfig.meta.ogImage}`,
    address: {
      "@type": "PostalAddress",
      streetAddress: siteConfig.address.streetAddress,
      addressLocality: siteConfig.address.addressLocality,
      postalCode: siteConfig.address.postalCode,
      addressCountry: "FI",
    },
    telephone: siteConfig.phone,
    url: siteConfig.meta.siteUrl,
    openingHours: hoursArray,
  };

  return (
    <Head>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
      />
    </Head>
  );
}
